<div class="container-fluid">
  <div class="page-header">
    <h1>{{translate.instant('pages.gatewayTimeoutMsg')}}</h1>
  </div>
</div>
